import React from 'react'
import styles from './NotificationsToolbar.module.css'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Button
} from '@mui/material'
import {
  Drafts
} from '@mui/icons-material'
import {
  READ_NOTIFICATION,
  SELECTED_NOTIFICATIONS
} from '../../Redux/Actions/Notifications'

const NotificationsToolbarRead = () => {
  const dispatch = useDispatch()
  const device = useSelector(state => state.device)
  const user = useSelector(state => state.login.user)
  const selected = useSelector(state => state.notifications.selected)
  const notifications = useSelector(state => state.notifications.notifications)
  return (
    <Button
      color="primary"
      variant="contained"
      className={styles.read}
      disabled={(selected.length === 0)}
      onClick={() => {
        const array = notifications.filter(item =>
          selected.includes(item.id) &&
          (item.read.indexOf(user.unique_id_user) < 0)
        )
        dispatch(READ_NOTIFICATION(array.map(item => item.id), user.unique_id_user, 1))
        dispatch(SELECTED_NOTIFICATIONS([]))
      }}
      startIcon={
        (device.desktop)
          ? <Drafts/>
          : undefined
      }
    >
      {
        (device.mobile)
          ? <Drafts/>
          : 'Marquer comme lu(s)'
      }
    </Button>
  )
}

export default NotificationsToolbarRead
